<template>
  <div>
    <b-row>
      <div class="col-12 text-success">
        <label>Seleccione el tipo de procedimiento:</label>
        <b-form-radio-group
          id="proc-tipo"
          v-model="tipoProcedimientoSelected"
          :options="tipoProcedimiento"
        ></b-form-radio-group>

        <div class="mt-1">
          <label>Seleccione el procedimiento a aplicar:</label>
          <v-select
            v-model="procedimientoSelected"
            :options="optionsProcedimiento"
            label="text"
            :reduce="(option) => option.value"
            placeholder="Busque..."
            clearable
          />

          <!-- <b-form-select class="mt-2" v-model="procedimientoSelected" placeholder="Seleccione un prcedimiento" :options="optionsProcedimiento"></b-form-select>
-->
        </div>

        <div class="mt-1">
          <b-button
            variant="warning"
            v-if="puedeAplicarProcedimiento"
            @click="aplicarProcedimiento"
          >
            Aplicar
          </b-button>
        </div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <div>
          <div class="Odontogram col-12" :class="svgInteractionClass">
            <svg version="1.1" height="100%" width="100%">
              <Teeth
                :start="18"
                :end="11"
                :x="0"
                :y="20"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />
              <Teeth
                :start="21"
                :end="28"
                :x="260"
                :y="20"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />

              <Teeth
                :start="48"
                :end="41"
                :x="0"
                :y="200"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />
              <Teeth
                :start="31"
                :end="38"
                :x="260"
                :y="200"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />

              <Teeth
                :start="55"
                :end="51"
                :x="75"
                :y="80"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />
              <Teeth
                :start="61"
                :end="65"
                :x="240"
                :y="80"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />

              <Teeth
                :start="85"
                :end="81"
                :x="75"
                :y="140"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />
              <Teeth
                :start="71"
                :end="75"
                :x="240"
                :y="140"
                :procedimientoSelected="procedimientoSelected"
                :tipoProcedimientoSelected="tipoProcedimientoSelected"
              />
            </svg>
          </div>
        </div>
      </div>
    </b-row>
    <hr />
    <b-row class="mt-1">
      <TableOdontograma
        :citaPosterior="citaPosterior"
        :items="itemsTabla"
        :newProcessCanDelete = "newProcessCanDelete"
        @update-items="actualizarItems"
      />

      <b-col class="col-10">
        <label>Observaciones</label>
        <b-form-textarea v-model="observaciones"> </b-form-textarea>
      </b-col>
      <b-col class="col-10">
        <label>Prescripciones</label>
        <b-form-textarea v-model="prescripciones"> </b-form-textarea>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BModal, BFormSelect } from "bootstrap-vue";
import Teeth from "./Teeth.vue";
import TableOdontograma from "./TableOdontograma.vue";
import vSelect from "vue-select";
import { comprobarRoles } from "../../../../shared/helpers";
import { ROLES } from "../../../../shared/constants";

export default {
  name: "Odontograma",
  components: {
    Teeth,
    BModal,
    BFormSelect,
    TableOdontograma,
    vSelect,
  },
  data() {
    return {
      newProcessCanDelete: [],
      observaciones: null,
      prescripciones: null,
      itemsTabla: [],
      procedimientoSelected: null,
      tipoProcedimientoSelected: "1",
      tipoProcedimiento: [
        { text: "Por hacer", value: "1" },
        { text: "Encontrado", value: "2" },
      ],

      optionsProcedimiento: [
        { text: "Caries en la zona", value: "caz", disabled: false },
        { text: "Caries en toda la pieza", value: "cap", disabled: false },
        { text: "Extraer/Extraida", value: "ext", disabled: false },
        { text: "Corona en pieza", value: "cop", disabled: false },
        { text: "Sellante", value: "sellante", disabled: false },
        { text: "Endodoncia", value: "end", disabled: false },
        { text: "Cuello base cavitaria", value: "cuello", disabled: false },
        { text: "Restauración", value: "restauracion", disabled: false },
        { text: "Incrustación", value: "incrustacion", disabled: false },
        { text: "Retratamiento", value: "retratamiento", disabled: false },
        { text: "Recromía", value: "recromia", disabled: false },
        { text: "Carilla", value: "carilla", disabled: false },
        {
          text: "Alargamiento corona",
          value: "alargamiento_corona",
          disabled: false,
        },
        { text: "Profilaxis", value: "profilaxis", disabled: false },
        {
          text: "Aplicación de flúor en gel",
          value: "aplicacion_fluor_gel",
          disabled: false,
        },
        {
          text: "Aplicación de flúor barniz",
          value: "aplicacion_fluor_barniz",
          disabled: false,
        },
        { text: "Microabrasión", value: "microabrasion", disabled: false },
        { text: "Sensibilidad", value: "sensibilidad", disabled: false },
        { text: "Retracción", value: "retraccion", disabled: false },
        { text: "Cirugía", value: "cirugia", disabled: false },
        {
          text: "Movilidad dental",
          value: "movilidad_dental",
          disabled: false,
        },
        { text: "Furca", value: "furca", disabled: false },
        { text: "Odontosección", value: "odontoseccion", disabled: false },
        {
          text: "Restos radiculares",
          value: "restos_radiculares",
          disabled: false,
        },
        {
          text: "Prótesis removible",
          value: "protesis_removible",
          disabled: false,
        },
        { text: "Prótesis total", value: "protesis_total", disabled: false },
        { text: "Puente", value: "puente", disabled: false },
        { text: "Perno", value: "perno", disabled: false },
        { text: "Periodoncia", value: "periodoncia", disabled: false },
        { text: "Odontoma", value: "odontoma", disabled: false },
        { text: "Quiste", value: "quiste", disabled: false },
        { text: "Blanqueamiento", value: "blanqueamiento", disabled: false },
        { text: "Férula", value: "ferula", disabled: false },
        {
          text: "Placa miorelajante",
          value: "placa_miorelajante",
          disabled: false,
        },
        {
          text: "Control ortodoncia",
          value: "control_ortodoncia",
          disabled: false,
        },
        { text: "Sin espacio", value: "sin_espacio", disabled: false },
        //{ text: "Supernumerario", value: "supernumerario", disabled: false },
      ],

      procedimientosPorHacer: [],
      procedimientosencontrados: [],
      number: null,
      yaInicializado: false,

      dataTooth: {
        zone: null,
        number: null,
        token: null,
      },
      dataDientes: null,
      currentZone: null,

      toothStates: [],

      firstUpdate: false,
      isHydrating: false,
    };
  },
  props: {
    odontogramaRecibido: {
      type: Object,
      default: null,
    },
    esCrear: {
      required: false,
      default: false,
    },
    citaPosterior: {
      required: false,
      default: false,
    },
  },
  computed: {
      isJefeMedico() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES]);
    },
    puedeAplicarProcedimiento() {
      const procedimientosPermitidos = [
        "aplicacion_fluor_gel",
        "aplicacion_fluor_barniz",
        "profilaxis",
        "cirugia",
        "blanqueamiento",
        "control_ortodoncia",
      ];

      return procedimientosPermitidos.includes(this.procedimientoSelected);
    },
    svgInteractionClass() {
      return this.puedeAplicarProcedimiento ? "svg-disabled" : "";
    },
  },

  methods: {
     generarToken(diente, zona) {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 100000);
      return `${diente}_${zona}_${timestamp}_${random}`;
    },

    aplicarProcedimiento() {
      const diente = "-";
      let token = this.generarToken(diente, 'all')

      // Guardamos en el store como referencia
      this.$store.commit("addDataDienteProcedimientoAll", {
        numeroPieza: diente,
        zonaProcedimiento: {
          all: {
            encontrado:false,
            realizado:false,
            selected:true,
            procedimiento: this.procedimientoSelected,
            token: token

          }
        }
      });

      this.newProcessCanDelete.push(token)

      this.procedimientoSelected = null; // ✅
    },

    actualizarItems(nuevosItems) {
      const tokensNuevos = new Set(
        nuevosItems.map((item) => item.token).filter((token) => !!token)
      );

      // Limpiar toothStates de los eliminados
      const eliminados = this.itemsTabla.filter(
        (item) => !tokensNuevos.has(item.token)
      );
      eliminados.forEach((item) => {
        this.removeToothStateByToken(item.token);
      });

      this.itemsTabla = [...nuevosItems];

      this.procedimientosPorHacer = this.procedimientosPorHacer.filter(
        (proc) => {
          const token = proc?.piezaDetails?.token;
          return !token || tokensNuevos.has(token);
        }
      );

      this.procedimientosencontrados = this.procedimientosencontrados.filter(
        (proc) => {
          const token = proc?.piezaDetails?.token;
          return !token || tokensNuevos.has(token);
        }
      );

      this.emitirOdontograma();
    },

    emitirOdontograma() {
      this.$emit("update-odontograma", {
        observaciones: this.observaciones,
        prescripciones: this.prescripciones,
        itemsTabla: this.itemsTabla,
        procedimientosPorHacer: this.procedimientosPorHacer,
        procedimientosencontrados: this.procedimientosencontrados,
        toothStates: this.toothStates,
        dataDientes: this.dataDientes,
      });
    },

    agregarState(code, value) {
      let existingState = this.toothStates.find(
        (state) => state.id === this.number
      );

      if (!existingState) {
        const token =
          this.dataTooth?.token ||
          this.generarToken(this.number, this.currentZone);
        const newToothState = {
          id: this.number,
          token: token,
          Cavities: {
            center: 0,
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          },
          Extract: 0,
          Crown: 0,
          Filter: 0,
          Fracture: 0,
          Sellante: 0,
        };
        this.toothStates.push(newToothState);
        existingState = newToothState;
      }

      // Ahora, actualizamos el estado basándonos en el tipo de acción
      if (code === "cavities") {
        // Acumulamos las cavidades sin borrar las otras
        existingState.Cavities[this.currentZone] = value;
      } else if (code === "allcavities") {
        // Reemplazamos todas las cavidades
        Object.assign(existingState.Cavities, value);
      } else {
        // Para cualquier otra acción, limpiamos todo el estado primero y luego actualizamos solo el campo
        // Limpiamos las cavidades
        //Object.assign(existingState.Cavities, { center: 0, top: 0, bottom: 0, left: 0, right: 0 });

        // Limpiamos los otros estados
        // existingState.Extract = 0;
        // existingState.Crown = 0;
        // existingState.Filter = 0;
        // existingState.Fracture = 0;

        // Ahora aplicamos el nuevo estado
        if (code === "extract") {
          existingState.Extract = value;
        } else if (code === "crown") {
          existingState.Crown = value;
        } else if (code === "filter") {
          existingState.Filter = value;
        } else if (code === "fracture") {
          existingState.Fracture = value;
        } else if (code === "sellante") {
          existingState.Sellante = value;
        }
      }
    },
    removeToothStateByToken(token) {
      const tooth = this.toothStates.find((t) => t.token === token);
      if (tooth) {
        // Limpiar el estado visual (cavidades y demás)
        Object.assign(tooth.Cavities, {
          center: 0,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        });
        tooth.Extract = 0;
        tooth.Crown = 0;
        tooth.Filter = 0;
        tooth.Fracture = 0;
        tooth.Sellante = 0;
      }
    },

    applyAction(type, zone = null, value = null) {
      console.log("entra a aplicar accion", type, zone, value);
      switch (type) {
        case "carie":
          this.setCavities(zone, value);
          break;
        case "extract":
          this.agregarState(type, value);

          break;
        case "crown":
          this.agregarState(type, value);

          break;
        case "filter":
          this.agregarState(type, value);

          break;
        case "sellante":
          this.agregarState(type, value);

          break;
        case "fracture":
          this.agregarState(type, value);

          break;
        case "enc":
          this.setCavities(zone, value);

          break;
        case "clear":
          this.clearTooth();
          break;
      }
    },
    setCavities(zone, value) {
      let cavities = {
        center: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      };
      if (zone === "all") {
        cavities = {
          center: value,
          top: value,
          bottom: value,
          left: value,
          right: value,
        };
        this.agregarState("allcavities", cavities);
      } else if (zone) {
        this.agregarState("cavities", value);
      }
    },
  },

  watch: {
    "$store.state.odontologia.dataDientes": {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (this.isHydrating) {
          this.dataDientes = newValue;
          return;
        }

        const normalizeLado = (lado) => {
          if (!lado) return lado;
          const map = {
            oclusal: "centro",
            vestibular: "arriba",
            palatina: "abajo",
            lingual: "abajo",
            mesial: "derecha",
            distal: "izquierda",
            cuello: "cuello",
            centro: "centro",
            arriba: "arriba",
            abajo: "abajo",
            izquierda: "izquierda",
            derecha: "derecha",
            all: "all",
          };

          const key = String(lado).toLowerCase();
          return map[key] || lado;
        };

        const nuevosItems = [];
        this.dataDientes = newValue;

        if (Array.isArray(newValue) && newValue.length) {
          newValue.forEach((diente) => {
            const numero = diente.numeroPieza;
            const zonas = diente.zonaProcedimiento || {};

            Object.entries(zonas).forEach(([zona, detalle]) => {
              if (detalle !== null) {
                nuevosItems.push({
                  token: detalle.token || null,
                  number: numero,
                  lado: zona,
                  procedimiento: detalle.procedimiento || null,
                  encontrado: detalle.encontrado || false,
                  realizado: detalle.realizado || false,
                  procedimiento_cie: detalle.procedimiento_cie || null,
                  diag_1: detalle.diag_1 || null,
                  diag_2: detalle.diag_2 || null,
                  medico: detalle.medico || null,
                  fecha_realizacion: detalle.fecha_realizacion || null,
                });
              }
            });
          });
        }

        // 🔁 Actualiza itemsTabla preservando información si es posible
        const itemsActualizados = [];

        nuevosItems.forEach((nuevoItem) => {
          let existente = null;
          if (nuevoItem.token) {
            existente = this.itemsTabla.find((i) => i.token === nuevoItem.token);
          }
          if (!existente) {
            existente = this.itemsTabla.find(
              (i) =>
                i.number === nuevoItem.number &&
                normalizeLado(i.lado) === normalizeLado(nuevoItem.lado)
            );
          }
          if (existente) {
            itemsActualizados.push({
              ...existente,
              ...nuevoItem,
              procedimiento:
                nuevoItem.procedimiento ?? existente.procedimiento ?? null,
              procedimiento_cie:
                nuevoItem.procedimiento_cie ??
                existente.procedimiento_cie ??
                null,
            });
          } else {
            itemsActualizados.push(nuevoItem);
          }
        });

        if (itemsActualizados.length || !this.itemsTabla.length) {
          this.itemsTabla = [...itemsActualizados];
        }
      },
    },

    esCrear: {
      handler(newVal) {

        //
      },
      immediate: true,
      deep: true,
    },

    toothStates: {
      handler(newVal) {
        // if (this.firstUpdate) {
        //   this.firstUpdate = false;
        // } else {
        //   this.handleToothUpdate(this.number, newVal);
        this.emitirOdontograma();
        this.$store.commit("setToothState", newVal);

        // this.handleToothUpdate(this.number, newVal);
      },
      immediate: true,
      deep: true,
    },
    citaPosterior: {
      handler(newVal) {
        let jefemedico = this.isJefeMedico
        if (newVal && !jefemedico ) {
          this.tipoProcedimiento = [{ text: "Por hacer", value: "1" }];
          this.optionsProcedimiento = [
            {
              text: "Aplicación de flúor en gel",
              value: "aplicacion_fluor_gel",
              disabled: false,
            },
            {
              text: "Aplicación de flúor barniz",
              value: "aplicacion_fluor_barniz",
              disabled: false,
            },

            { text: "Profilaxis", value: "profilaxis", disabled: false },

            { text: "Cirugía", value: "cirugia", disabled: false },

            {
              text: "Blanqueamiento",
              value: "blanqueamiento",
              disabled: false,
            },
            {
              text: "Control ortodoncia",
              value: "control_ortodoncia",
              disabled: false,
            },
          ];
        }
      },
      immediate: true,
      deep: true,
    },
    tipoProcedimientoSelected: {
  handler(newVal) {
    this.procedimientoSelected = null
    let jefemedico = this.isJefeMedico
    // Items que vamos a agregar o eliminar
    const itemEnc = { text: "Encontrado", value: "enc", disabled: false };

    const itemsTipo1 = [
             { text: "Caries en la zona", value: "caz", disabled: false },
        { text: "Caries en toda la pieza", value: "cap", disabled: false },
    ];

    // Eliminamos los 3 condicionales antes de agregar según el caso
    const valoresAEliminar = ["enc", "caz", "cap"];
    this.optionsProcedimiento = this.optionsProcedimiento.filter(
      (item) => !valoresAEliminar.includes(item.value)
    );


    // Agregar según el valor seleccionado
    if (newVal === "1") {
      // Agregamos caz y cap
      if(!this.citaPosterior) {
        this.optionsProcedimiento.push(...itemsTipo1);
      }else if(this.citaPosterior && jefemedico) {
        this.optionsProcedimiento.push(...itemsTipo1);
      }
      
    } else if (newVal === "2") {
      // Agregamos enc
      this.optionsProcedimiento.push(itemEnc);
    }
  },
  immediate: true, // Opcional si quieres que se ejecute al inicio
  deep:true,
},


    procedimientosPorHacer: {
      handler(newVal) {
        console.log("por hacer", newVal);
        this.emitirOdontograma();
        if (newVal.length > 0) {
          // Solo procesamos el último elemento, para evitar el bucle infinito
          const value = newVal[newVal.length - 1];
          let election = value.procedimiento;
          let zone = value.piezaDetails.zone;
          let valor = value.value;

          switch (election) {
            case "caz":
              this.applyAction("carie", zone, valor);
              break;
            case "cap":
              this.applyAction("carie", "all", valor);
              break;
            case "ext":
              this.applyAction("extract", null, valor);
              break;
            case "cop":
              this.applyAction("crown", null, valor);
              break;
            case "sellante":
              this.applyAction("sellante", null, valor);
              break;
            case "end":
              this.applyAction("filter", null, valor);
              break;
          }

          // Borra el elemento procesado para no volver a ejecutar la acción
          //this.procedimientosPorHacer.pop();
        }
      },
      deep: true,
      immediate: true,
    },

    procedimientosencontrados: {
      handler(newVal) {
        console.log("encontrados", newVal);
        this.emitirOdontograma();
        if (newVal.length > 0) {
          // Solo procesamos el último elemento, para evitar el bucle infinito
          const value = newVal[newVal.length - 1];
          let election = value.procedimiento;
          let zone = value.piezaDetails.zone;
          let valor = value.value;

          switch (election) {
            case "caz":
              this.applyAction("carie", zone, valor);
              break;
            case "cap":
              this.applyAction("carie", "all", valor);
              break;
            case "ext":
              this.applyAction("extract", null, valor);
              break;
            case "cop":
              this.applyAction("crown", null, valor);
              break;
            case "end":
              this.applyAction("filter", null, valor);
              break;
            case "sellante":
              this.applyAction("sellante", null, valor);
              break;
            case "enc":
              this.applyAction("enc", zone, valor);
              break;
          }

          // Borra el elemento procesado para no volver a ejecutar la acción
          //this.procedimientosPorHacer.pop();
        }
      },
      deep: true,
      immediate: true,
    },
    observaciones: {
      handler() {
        this.emitirOdontograma();
      },
      deep: true,
      immediate: true,
    },
    prescripciones: {
      handler() {
        this.emitirOdontograma();
      },
      deep: true,
      immediate: true,
    },
    itemsTabla: {
      handler() {
        this.emitirOdontograma();
      },
      deep: true,
      immediate: true,
    },
    odontogramaRecibido: {
      handler(newVal) {
        if (!this.yaInicializado && newVal) {
          console.log("🦷 Odontograma recibido:", newVal);
          this.isHydrating = true;

          if (newVal.observaciones !== undefined) {
            this.observaciones = newVal.observaciones;
          }

          if (newVal.prescripciones !== undefined) {
            this.prescripciones = newVal.prescripciones;
          }

          if (Array.isArray(newVal.itemsTabla)) {
            this.itemsTabla = newVal.itemsTabla.map((item) => ({
              ...item,
              original: true,
            }));
          }

          if (Array.isArray(newVal.procedimientosPorHacer)) {
            this.procedimientosPorHacer = [...newVal.procedimientosPorHacer];
          }

          if (Array.isArray(newVal.procedimientosencontrados)) {
            this.procedimientosencontrados = [
              ...newVal.procedimientosencontrados,
            ];
          }

          if (Array.isArray(newVal.toothStates)) {
            this.toothStates = [...newVal.toothStates];
          }

          if (Array.isArray(newVal.dataDientes)) {
            this.dataDientes = [...newVal.dataDientes];
            this.$store.commit("cleanDataDientes", this.dataDientes);
          }

          //this.emitirOdontograma(); // ✅ Emitimos para informar que se ha cargado
          this.yaInicializado = true;
          this.$nextTick(() => {
            this.isHydrating = false;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
@import "./Odontograma.css";
</style>
